import { render, staticRenderFns } from "./apply-next.vue?vue&type=template&id=970cd41c"
import script from "./apply-next.vue?vue&type=script&lang=js"
export * from "./apply-next.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports